<template lang="html">
  <v-flex
    pa-0
    class="si-stop-children-breaking"
  >
    <!-- <v-flex xs12 v-if="section.textPre" v-html="_templateLiteralString(section.textPre)"></v-flex> -->
    <v-flex
      v-if="section.textPre"
      xs12
      v-html="section.textPre"
    />

    <v-simple-table
      class="si-plain-table py-4"
      dense
    >
      <tbody>
        <tr class=" no-hover">
          <td class="px-1 subtitle-2">
            <i>Supplied assumptions</i>
          </td>
        </tr>
        <tr
          v-for="(field, fId) in fields"
          :key="`supplied_${fId.toString()}`"
        >
          <template v-if="field.type === 'input'">
            <td
              class="si-dense-row-padding si-assumptions-label px-1"
              v-html="field.label"
            />
            <td
              class="si-dense-row-padding si-assumptions-value font-weight-bold"
              style="min-width:150px"
            >
              <span
                v-if="field.value === 'nil'"
                class="grey--text font-italic "
              >{{ field.value }}</span>
              <span
                v-else
                class="text-no-wrap-xx"
              >{{ field.value }}</span>
            </td>
          </template>
          <template v-if="field.type === 'multi'">
            <td
              colspan="2"
              class="px-0"
            >
              <tr class=" no-hover">
                <td
                  colspan="2"
                  class="px-1"
                >
                  {{ field.label }}
                </td>
              </tr>

              <v-simple-table
                class="si-plain-table transparent mb-2"
                dense
              >
                <tbody>
                  <tr class=" no-hover">
                    <td
                      v-if="!field.values"
                      colspan="2"
                      class="font-italic grey--text"
                    >
                      nil
                    </td>
                    <td
                      v-if="field.values"
                      class="px-1"
                      colspan="2"
                    >
                      <v-simple-table
                        class="si-plain-table transparent"
                        dense
                      >
                        <thead>
                          <tr class="no-hover">
                            <th
                              v-for="(label, lId) in field.labels"
                              :key="lId"
                              v-html="label"
                            />
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(row, rId) in field.values"
                            :key="fId.toString() + rId"
                          >
                            <td
                              v-for="(item, iId) in row"
                              :key="iId"
                              :width="`${100 / (row || []).length}%`"
                              class="si-dense-row-padding si-assumptions-value font-weight-bold"
                            >
                              <span
                                v-if="item === 'nil'"
                                class="grey--text font-italic"
                              >{{ item }}</span>
                              <span
                                v-else
                                class="text-no-wrap-xx"
                              >{{ item }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </td>
          </template>
        </tr>
        <tr
          v-if="computedFields.length > 0"
          class="no-hover"
        >
          <td class="px-1 pt-6 subtitle-2">
            <i>Computed assumptions</i>
          </td>
        </tr>
        <tr
          v-for="(field, fId) in computedFields"
          :key="`computed_${fId.toString()}`"
        >
          <td
            class="si-dense-row-padding si-assumptions-label px-1"
            v-html="field.label"
          />
          <td
            class="si-dense-row-padding si-assumptions-value font-weight-bold"
            style="min-width:150px"
          >
            <span
              v-if="field.value === 'nil'"
              class="grey--text font-italic "
            >{{ field.value }}</span>
            <span
              v-else
              class="text-no-wrap-xx"
            >{{ field.value }}</span>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- <v-flex xs12 v-if="section.textPost" v-html="_templateLiteralString(section.textPost)"></v-flex> -->
    <v-flex
      v-if="section.textPost"
      xs12
      v-html="section.textPost"
    />
  </v-flex>
</template>

<script>
import helpers from '@/mixins/helpers'
export default {
  mixins: [ helpers ],
  props: {
    data: Object,
    section: Object
  },
  computed: {
    report () {
      return this.data.report || {}
    },
    assumptions () {
      // return this._sortObject({ ...this.report.assumptions, ...{ computedAssumptions: this.computedAssumptions } })
      return this._sortObject(this.report.assumptions)
    },
    fields () {
      let fields = this.assumptions
        .map(section => section.fields || [])
        .flat()

      return [
        ...fields.filter(f => f.type !== 'multi'),
        ...fields.filter(f => f.type === 'multi')
      ]
    },
    computedFields () {
      return this.report.computed || []
    },
    computedAssumptions () {
      return (this.report.computed || []).length > 0
        ? {
          index: 99,
          label: 'Computed assumptions',
          type: 'section',
          fields: (this.report.computed || []).map(i => { return { ...i, ...{ type: 'input', label: `${i.label} <i>(computed)</i>` } } })
        }
        : {}
    }
  }
}
</script>

<style lang="css" scoped>
.si-dense-row-padding {
  padding-top:1px;
  padding-bottom:1px
}
@media screen and (min-width: 800px) {
  .si-assumptions-value {
    white-space: nowrap;
  }
}

@media print {
  .si-assumptions-value {
    white-space: nowrap;
  }
}
</style>
